export const discaimerText = {
	FHA: `PAYMENT INCLUDES A ONE-TIME UPFRONT MORTGAGE INSURANCE PREMIUM (MIP) AT 1.75% OF THE
     BASE LOAN AMOUNT AND A MONTHLY MIP CALCULATED AT 0.55% OF THE BASE LOAN AMOUNT. THE 0.55%
     MONTHLY MIP IS REQUIRED FOR A SPECIFIC PERIOD OF TIME REGARDLESS OF YOUR DOWN PAYMENT OR
     EQUITY IN YOUR HOME.`,
};

export const lpLoanType = {
	Affordable: 'Conventional',
	Conventional: 'Conventional',
	VA: 'VA',
	USDA: 'UsdaRural',
	FHA: 'FHA',
};

export const lpOccupancyType = {
	SecondHome: 'SecondaryVacation',
	Investment: 'Investment',
};

export const lpLoanPurpose = {
	Refinance: 'Refinance',
	Purchase: 'Purchase',
};

export const lpRefinancePurpose = {
	CashOut: 'CashOut',
	RateAndTerm: 'RateTerm',
	Purchase: 'Purchase',
};

export const cashOutPurpose = {
	VATypeOne: 'CASH_OUT_VA_TYPE1',
	VATypeTwo: 'CASH_OUT_VA_TYPE2',
	VAIRRRL: 'RATE_TERM',
};

export const lenderPriceDropDownOptions = {
	mortgageInsuranceTypeOptions: [
		{
			name: 'LPMI (Lender Paid)',
			value: true,
			id: 1,
		},
		{
			name: 'BPMI (Monthly)',
			value: false,
			id: 2,
		},
	],
	loanTypeOptions: {
		captions: ['Conventional', 'FHA', 'Affordable', 'VA', 'USDA'],
		values: [
			{
				name: 'Conventional',
				value: 'Conventional',
			},
			{
				name: 'FHA',
				value: 'FHA',
			},
			{
				name: 'Affordable',
				value: 'Conventional',
			},
			{
				name: 'VA',
				value: 'VA',
			},
			{
				name: 'USDA',
				value: 'UsdaRural',
			},
		],
	},
	amortizationTypeOptions: [
		{
			name: 'Fixed Rate',
			value: ['Fixed'],
			id: 1,
		},
		{
			name: 'Adjustable Rate',
			value: ['Variable'],
			id: 2,
		},
		{
			name: 'Both',
			value: ['Variable', 'Fixed'],
			id: 3,
		},
	],
	serviceType: [
		{
			name: 'Active/Veteran',
			value: 'Active_Or_Veteran',
			id: 1,
		},
		{
			name: 'Reserves/National Guard',
			value: 'Reserves_Or_National_Guard',
			id: 2,
		},
	],
	vaUseType: [
		{
			name: 'First Use',
			value: 'First_Use',
			id: 1,
		},
		{
			name: 'Subsequent Use',
			value: 'Subsequent_Use',
			id: 2,
		},
	],
	loanPurpose: [
		{
			name: 'Purchase',
			value: 'Purchase',
			id: 1,
		},
		{
			name: 'Refinance',
			value: 'Refinance',
			id: 2,
		},
	],
	refinancePurpose: [
		{
			name: 'Cash Out',
			value: 'CashOut',
			id: 1,
		},
		{
			name: 'Rate and Term',
			value: 'RateTerm',
			id: 2,
		},
	],
	cashOutPurpose: [
		{
			name: 'Cash Out - Consolidation',
			value: 'CashoutConsolidation',
			id: 1,
		},
		{
			name: 'Cash Out - Improvement',
			value: 'CashoutImprovement',
			id: 2,
		},
		{
			name: 'Cash Out - Other',
			value: 'CashOutOther',
			id: 3,
		},
		{
			name: 'Cash Out - Student Loan Only',
			value: 'CashoutStudentLoan',
			id: 4,
		},
	],
	vaCashOutPurpose: [
		{
			name: 'VA Cash Out - Type I',
			value: 'CASH_OUT_VA_TYPE1',
			id: 1,
		},
		{
			name: 'VA Cash Out - Type II',
			value: 'CASH_OUT_VA_TYPE2',
			id: 2,
		},
	],
	occupancy: [
		{
			name: 'Primary Residence',
			value: 'PrimaryResidence',
			id: 1,
		},
		{
			name: 'Secondary Residence',
			value: 'SecondaryVacation',
			id: 2,
		},
		{
			name: 'Investment Property',
			value: 'Investment',
			id: 3,
		},
		{
			name: 'Investment-Occupy 14 Days',
			value: 'Investment',
			id: 4,
		},
	],
	propertyType: [
		{
			name: 'Single Family Residence',
			value: 'SingleFamily',
			id: 1,
		},
		{
			name: 'Condominium',
			value: 'Condos',
			id: 2,
		},
		{
			name: 'Manufactured Single',
			value: 'ManufacturedHousingSingleWide',
			id: 3,
		},
		{
			name: 'Manufactured Multi',
			value: 'ManufacturedHousingDoubleWide',
			id: 4,
		},
		{
			name: 'Manufactured PUD Single',
			value: 'ManufacturedHousingSingleWide',
			id: 5,
		},
		{
			name: 'Manufactured PUD Multi',
			value: 'ManufacturedHousingDoubleWide',
			id: 6,
		},
		{
			name: 'Manufactured Condo Single',
			value: 'ManufacturedHousingSingleWide',
			id: 7,
		},
		{
			name: 'Manufactured Condo Multi',
			value: 'ManufacturedHousingMultiWide',
			id: 8,
		},
		{
			name: '2-4 Unit Dwelling',
			value: 'UnitDwelling_2_4',
			id: 9,
		},
		{
			name: 'Site Condo',
			value: 'SiteCondo',
			id: 10,
		},
		{
			name: 'Planned Unit Development',
			value: 'PlannedUnitDevelopment',
			id: 11,
		},
	],
	commitmentPeriod: [
		{
			name: '15 Day Lock',
			value: 15,
			id: 1,
		},
		{
			name: '30 Day Lock',
			value: 30,
			id: 2,
		},
		{
			name: '45 Day Lock',
			value: 45,
			id: 3,
		},
		{
			name: '60 Day Lock',
			value: 60,
			id: 4,
		},
		{
			name: '90 Day Lock',
			value: 90,
			id: 5,
		},
	],
	compensationType: [
		{
			name: 'Lender Paid',
			value: false,
			id: 1,
		},
		{
			name: 'Borrower Paid',
			value: true,
			id: 2,
		},
	],
	documentationType: [
		{
			name: 'Full',
			value: 'Full Doc - 24M',
			id: 1,
		},
		{
			name: 'Streamline',
			value: 'REDUCED_DOC',
			id: 2,
		},
	],
	escrowImpoundType: [
		{
			name: 'No Waiver',
			value: 'NONE_WAIVED',
			id: 1,
		},
		{
			name: 'Waive Taxes and Hazard Insurance',
			value: 'ALL_WAIVED',
			id: 2,
		},
		{
			name: 'Waive Taxes Only',
			value: 'PROPERTY_TAXES_WAIVED',
			id: 3,
		},
		{
			name: 'Waive Hazard Insurance Only',
			value: 'HAZARD_INSURANCE_WAIVED',
			id: 4,
		},
	],
	loanTerm: {
		captions: ['30 Years', '25 Years', '20 Years', '15 Years', '10 Years'],
		values: [
			{
				name: '30 Years',
				value: 30,
			},
			{
				name: '25 Years',
				value: 25,
			},
			{
				name: '20 Years',
				value: 20,
			},
			{
				name: '15 Years',
				value: 15,
			},
			{
				name: '10 Years',
				value: 10,
			},
		],
	},
	firstTimeHomebuyer: [
		{
			name: 'Yes',
			value: true,
			id: 1,
		},
		{
			name: 'No',
			value: false,
			id: 2,
		},
	],
};


export const errorMessages = {
	loanAmount: 'Please enter a valid loan amount.',
	salesPrice: 'Please enter a valid sales price.',
	selectedMortgageInsuranceType: 'Please select a mortgage insurance type.',
	selectedLoanType: 'Please select at least one loan type.',
	selectedAmortizationType: 'Please select an amortization type.',
	selectedVAUseType: 'Please select a VA use type.',
	selectedServiceType: 'Please select a service type.',
	selectedLoanPurpose: 'Please select a purpose.',
	selectedRefinancePurpose: 'Please select a refinance purpose',
	selectedCashOutPurpose: 'Please select a cash out purpose',
	selectedOccupancy: 'Please select an occupancy type.',
	propertiesFinanced: 'Please enter number of financed properties.',
	selectedPropertyType: 'Please select a property type.',
	numberOfUnits: 'Please enter number of units.',
	propertyZip: 'Please enter a valid ZIP code.',
	creditScore: 'Please enter a valid credit score.',
	selectedCommitmentPeriod: 'Please select a commitment period.',
	selectedCompensationType: 'Please select a compensation type.',
	selectedDocumentationType: 'Please select a documentation type.',
	selectedEscrowImpoundType: 'Please select an escrow/impound type.',
	selectedLoanTerm: 'Please select at least one loan term.',
	selectedFirstTimeHomebuyer: 'Please select an option.',
	monthlyIncome: 'Please enter monthly income.',
	monthlyDebt: 'Please enter monthly debt.',
	annualTaxes: 'Please enter annual taxes.',
	annualHoi: 'Please enter annual HOI.',
};

export const loanOfficerOptions = {
	API_CALL_FAILED: 'API call failed',
	INVALID_ID: 'invalid broker id',
	INVALID_NMLS: 'invalid broker NMLS',
};
